import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input, signal, ViewEncapsulation } from '@angular/core';
import { IconField, IconFieldModule } from 'primeng/iconfield';

@Component({
  selector: 'osp-icon-field',
  standalone: true,
  imports: [IconFieldModule, NgClass],
  templateUrl: './icon-field.component.html',
  styleUrl: './icon-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class IconFieldComponent {
  $iconPosition = input<IconField['iconPosition']>('left', { alias: 'iconPosition' });

  private classPositionMap: Record<IconField['iconPosition'], string> = {
    left: 'p-left',
    right: 'p-right',
  }
  private $iconAmount = signal(0);
  $class = computed(() => [
    this.classPositionMap[this.$iconPosition()],
    this.$iconAmount() > 0 ? `input-icon-amount-${this.$iconAmount()}` : ''
  ].filter(Boolean).join(' '));

  setIconAmount(iconAmount: number) {
    this.$iconAmount.set(iconAmount);
  }

}
